import { gql } from '@apollo/client'

export const SAVE_PINS_TO_JOB_FOLDERS = gql`
  mutation createWorkspaceJobPins(
    $createWorkspaceJobPinInput: [CreateWorkspaceJobPinInput!]!
    $workspaceJobId: String!
  ) {
    createWorkspaceJobPins(createWorkspaceJobPinInput: $createWorkspaceJobPinInput, workspaceJobId: $workspaceJobId) {
      success
      message
    }
  }
`
